import { ListItemProps } from 'src/components';

export const isElementVisible = (
  element: Element | null
): { top: boolean; bottom: boolean; right: boolean; left: boolean } => {
  if (!element) {
    return { top: false, bottom: false, right: false, left: false };
  }

  const MARGIN = 8;
  const { top, bottom, left, right } = element.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  const { clientHeight, clientWidth } = document.documentElement;

  return {
    top: top < MARGIN,
    bottom: bottom + MARGIN > (innerHeight || clientHeight),
    left: left < MARGIN,
    right: right + MARGIN > (innerWidth || clientWidth)
  };
};

export const debounce = (func: () => void, wait: number) => {
  let timeout: NodeJS.Timeout;
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(), wait);
  };
};

export const generateUniqueIdentifier = (item: ListItemProps): string => {
  return `${item.id}-${item.label}-${item.start}-${item.tooltip}-${item.description}-${item.end}`;
};

// prefix is must have `clientos-ui-toolkit-` prefix. Automation team is excluding this prefix from the selector.
export const generateID = (prefix: string = 'clientos-ui-toolkit'): string => {
  return prefix + '-' + Math.random().toString(36).substring(2, 9);
};
